import Tokopedia from "public/static/images/svg/tokopedia.svg";
import Bukalapak from "public/static/images/svg/bukalapak_ic.svg";
import Blibli from "public/static/images/svg/blibli.svg";
import Shopee from "public/static/images/png/mitra/shopee.png";

export const ECommerceData = [
  {
    icon: Tokopedia,
    title: "tokopedia",
    sections: [
      {
        title: "Pembayaran melalui Website Tokopedia",
        steps: [
          `Klik <a style="color: var(--color-red)" href="https://tokopedia.link/homecredit?utm_source=partner_website_&utm_medium=brand&utm_campaign=home-creditaon" target="_blank">di sini</a> untuk membayar menggunakan Tokopedia`,
          `Masukkan <b>NOMOR KONTRAK</b>`,
          `Masukkan <b>TOTAL TAGIHAN</b> yang ingin dibayarkan`,
          `Pilih <b>LANJUT</b>`,
          `Pilih <b>METODE PEMBAYARAN</b>`,
          `Periksa kembali data anda apakah sudah benar atau belum, jika sudah benar silahkan lakukan pembayaran`,
          `Pastikan untuk selalu menyimpan bukti pembayaran angsuran`,
        ],
      },
      {
        title: "Pembayaran melalui Aplikasi Tokopedia",
        steps: [
          `Buka aplikasi Tokopedia`,
          `Klik menu <b>TAGIHAN</b>`,
          `Pilih menu <b>ANGSURAN KREDIT</b>`,
          `Pilih <b>PRODUK ANGSURAN KREDIT : HOME CREDIT</b>`,
          `Masukkan <b>NOMOR KONTRAK</b>`,
          `Masukkan <b>TOTAL TAGIHAN</b> yang ingin dibayarkan`,
          `Pilih <b>LANJUT</b>`,
          `Pilih <b>METODE PEMBAYARAN</b>`,
          `Periksa kembali data anda apakah sudah benar atau belum, jika sudah benar silahkan lakukan pembayaran`,
          `Pastikan untuk selalu menyimpan bukti pembayaran angsuran`,
        ],
      },
    ],
  },
  {
    icon: Bukalapak,
    title: "bukalapak",
    sections: [
      {
        title: "Pembayaran melalui Website Bukalapak",
        steps: [
          `Klik <a style="color: var(--color-red)" href="https://www.bukalapak.com/angsuran-kredit?referrer=channel-hci" target="_blank">di sini</a> untuk membayar menggunakan Bukalapak`,
          `Log in dengan akun Bukalapak kamu`,
          `Pada halaman utama, klik menu <b>E-VOUCHER & TIKET</b> dan pilih <b>ANGSURAN KREDIT</b>`,
          `Pilih <b>HOME CREDIT</b> pada <b>PENYEDIA JASA</b>`,
          `Masukkan nomor kontrak untuk melihat rincian tagihan`,
          `Masukkan nominal pembayaran`,
          `Klik <b>BAYAR TAGIHAN</b> untuk melanjutkan proses pembayaran`,
          `Pilih metode pembayaran yang diinginkan`,
          `Klik <b>BAYAR</b> untuk melanjutkan`,
        ],
      },
      {
        title: "Pembayaran melalui Aplikasi Bukalapak",
        steps: [
          `Buka aplikasi Bukalapak`,
          `Log in dengan akun Bukalapak kamu`,
          `Plih <b>MENU FAVORIT</b> di halaman utama, tekan LAINNYA lalu <b>ANGSURAN KREDIT</b>`,
          `Pilih <b>HOME CREDIT</b> pada <b>PENYEDIA JASA</b>`,
          `Masukkan nomor kontrak untuk melihat rincian tagihan`,
          `Masukkan nominal pembayaran`,
          `Pilih <b>BAYAR TAGIHAN</b> untuk melanjutkan proses pembayaran`,
          `Pilih metode pembayaran yang diinginkan`,
          `Pilih <b>BAYAR</b> untuk melanjutkan`,
        ],
      },
    ],
  },
  {
    icon: Blibli,
    title: "blibli",
    sections: [
      {
        title: `Pembayaran melalui Aplikasi Blibli`,
        steps: [
          `Klik <a style="color: var(--color-red)" href="https://www.blibli.com/digital/p/angsuran-kredit/home-credit" target="_blank">di sini</a> atau buka aplikasi Blibli, Log in dengan akun Blibli kamu          `,
          `Pilih menu <b>Tagihan & Isi Ulang</b>  di Beranda, tekan <b>Angsuran Kredit</b>`,
          `Pada Nama Perusahaan pilih HOME CREDIT`,
          `Masukkan nomor kontrak, dan info tagihan akan muncul`,
          `Pastikan rincian tagihan, pilih <b>Lanjut ke Pembayaran</b>`,
          `Pilih <b>Buat Pesanan</b> untuk melanjutkan proses pembayaran`,
          `Pilih metode pembayaran yang diinginkan`,
          `Pilih <b>Bayar sekarang</b> untuk melanjutkan`,
        ],
      },
      {
        title: `Pembayaran melalui website blibli.com`,
        steps: [
          `Klik <a style="color: var(--color-red)" href="https://www.blibli.com/digital/p/angsuran-kredit/home-credit" target="_blank">di sini</a> atau buka laman www.blibli.com`,
          `Log in dengan akun Blibli kamu`,
          `Pilih menu <b>Tagihan & Isi Ulang</b>  di Beranda, tekan <b>Angsuran Kredit</b>`,
          `Pada kolom Perusahaan pilih <b>HOME CREDIT</b>`,
          `Masukkan nomor kontrak, pilih <b>Lihat tagihan</b>`,
          `Pastikan rincian tagihan, pilih <b>Lanjut bayar</b>`,
          `Pilih metode pembayaran yang diinginkan`,
          `Klik <b>Bayar sekarang</b> untuk melanjutkan`,
          `Bayar cicilan sesuai metode yang dipilih`,
        ],
      },
    ],
  },
  {
    icon: Shopee,
    title: "Shopee",
    scale: "0.75",
    sections: [
      {
        title: `Pembayaran Melalui Aplikasi Shopee`,
        steps: [
          `Buka aplikasi Shopee lalu Log In dengan akun Shopee kamu`,
          `Masuk ke menu <b>PULSA</b>, <b>TAGIHAN</b>  lalu <b>HIBURAN</b> kemudian pilih <b>ANGSURAN KREDIT</b>`,
          `Pada “Penyedia Layanan” pilih <b>HOME CREDIT</b>`,
          `Masukkan 10 Digit Nomor Kontrak pada Kolom No Pelanggan, dan informasi nominal tagihan akan muncul. Kemudian klik “Lanjutkan”`,
          `Pastikan Nomor Kontrak, Nama Pelanggan dan Total Tagihan sudah sesuai dan pilih metode pembayaran yang ingin digunakan. Kemudian klik "Bayar Sekarang". (Pelanggan juga dapat memasukkan kode voucher promo jika tersedia)`,
          `Masukkan PIN Shopee Pay (untuk metode pembayaran Shopee Pay) untuk melanjutkan proses pembayaran`,
          `Pelanggan akan menerima rincian pesanan atas transaksi pembayaran yang dilakukan`,
          `Pelanggan menerima notifikasi bahwa pesanan akan di proses`,
        ],
      },
    ],
  },
];
